import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <Link to="/" className="block mb-4" aria-label="Ir a la página principal">
              <motion.div
                className="w-40 h-12 bg-contain bg-no-repeat bg-center"
                style={{ backgroundImage: 'url(/logos/humancall-logo.svg)' }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                whileHover={{ scale: 1.05 }}
                role="img"
                aria-label="Logo de HumanCall"
              />
            </Link>
            <p className="text-gray-400">Transformando la atención al cliente con tecnología e innovación</p>
          </div>
          <nav>
            <h3 className="text-lg font-semibold mb-4">Servicios</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/soluciones" className="hover:text-white transition-colors">Nuestras Soluciones</Link></li>
              <li><Link to="/contacto" className="hover:text-white transition-colors">Solicitar Demo</Link></li>
            </ul>
          </nav>
          <div>
            <h3 className="text-lg font-semibold mb-4">Empresa</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/nosotros" className="hover:text-white transition-colors">Sobre Nosotros</Link></li>
              <li><Link to="/contacto" className="hover:text-white transition-colors">Contacto</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/privacidad" className="hover:text-white transition-colors">Privacidad</Link></li>
              <li><Link to="/terminos" className="hover:text-white transition-colors">Términos</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} HumanCall. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 